import { CostBasisPosition } from '@interfaces/cost-basis/cost-basis.service.interface';
import { GiftingState, TriageState } from '@interfaces/state';

import { FilteredAccount } from './client-accounts.interface';
import { CostBasisMethods } from './cost-basis-methods';
import { GiftRecipientTypes } from './gift-recipient-types';
import { GiftingDesignationTypes } from './gifting-designation-types';
import { MultiSignerSignState } from './mxm-sign-state.enum';

export interface JointGiftingApprovalDBPayload {
  gift: Omit<GiftingState, 'jointGiftingApprovalStatus'>;
  triage: Pick<TriageState, 'accountTypeInheriting' | 'giftingDesignation' | 'flowType'>;
  account: JointGiftingApprovalDBPayloadFilteredAccount;
  positions: CostBasisPosition[];
}

export type JointGiftingApprovalDBPayloadFilteredAccount = Pick<
  FilteredAccount,
  | 'accountId'
  | 'accountName'
  | 'accountNumber'
  | 'accountType'
  | 'productType'
  | 'registeredRoles'
  | 'grantedRoles'
>;

export interface JointGiftingApprovalGift {
  anonymous: boolean;
  dtcNumber: string;
  type: GiftRecipientTypes;
  firm: string;
  recipientName: string;
  accountNumber: string;
  giftDesignation: GiftingDesignationTypes;
}

export interface JointGiftingApprovalTaxLot {
  lotID: string;
  selectedAmount: string;
}

export interface JointGiftingApprovalPosition {
  positionId: string;
  giftingMethod: string;
  costBasisMethod?: CostBasisMethods;
  selectedAmount: string;
  taxLots?: JointGiftingApprovalTaxLot[];
  additionalTaxLotId?: string;
}
export interface JointGiftingApprovalSourceAccount {
  accountId: string;
  accountNumber: string;
  positions: JointGiftingApprovalPosition[];
}

export interface JointGiftingApprovalPayload {
  gift: JointGiftingApprovalGift;
  sourceAccount: JointGiftingApprovalSourceAccount;
}

export interface JointGiftingDetailsResponse extends JointGiftingApprovalDBPayload {
  giftId: string;
  signState: MultiSignerSignState;
}
